<script setup>
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue"
import { useNotificationsStore } from '@/stores/NotificationsStore'
import { useRouter } from 'vue-router'

const notificationsStore = useNotificationsStore()

const router = useRouter()

const handleViewAllNotifications = () => {
  router.push('/notifications')
}
</script>
<template>
  <Menu as="div" class="relative">
    <MenuButton
      class="block w-fit mx-auto p-1.5 rounded-lg transition duration-300 focus:outline-none"
    >
      <Icon icon="heroicons:ellipsis-vertical-20-solid" class="text-xl" />
   </MenuButton>
    <Transition name="menu-scale">
      <MenuItems
        class="
          absolute z-10 top-full mt-2 right-0 rounded-lg bg-white shadow-lg ring-1 ring-gray-200
          focus:outline-none py-1
        "
      >
        <MenuItem>
          <button
            class="flex w-max items-center gap-x-2.5 px-3.5 py-2 text-sm transition duration-300 hover:bg-gray-100 text-gray-900"
            @click="handleViewAllNotifications"
          >
            <Icon icon="heroicons:eye-20-solid" class="text-base" />
            <span>View All Notifications</span>
          </button>
        </MenuItem>
        <MenuItem>
          <button
            class="text-red-600 flex w-full items-center gap-x-2.5 px-3.5 py-2 text-sm transition duration-300 hover:bg-gray-100"
            @click="notificationsStore.clearAllNotifications"
          >
            <Icon icon="heroicons:trash-20-solid" class="text-base" />
            <span>Clear All</span>
          </button>
        </MenuItem>
      </MenuItems>
    </Transition>
  </Menu>
</template>